
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableTabMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabMobileRT(): TemplateResult<fitmentTableTabMobileRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('div', { 'key': '0' }, _createElement('span', { 'className': 'page-heading' }, 'Fitment'), _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-keyboard-arrow-down' }))) : null;
}
        export const componentNames = []